import { getOwnPropertyDescriptor } from '@rehaje/shared'

export function getEnumerableOwnPropertyDescriptor(
  target?: object | undefined,
  key?: PropertyKey
) {
  if (!target) return target
  if (!key) return
  const descriptor = getOwnPropertyDescriptor(target, key)
  if (descriptor) descriptor.enumerable = true
  return descriptor
}

export const DefaultDescriptor = {
  configurable: true,
  enumerable: true
}
